import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult } from './types';

const waybillsWeighingAnalysesApi = {
  getAll(
    waybillId: number,
    params?: cyrian.api.waybillsWeighingAnalyses.GetParams,
  ): ApiResponse<WrappedResult<cyrian.api.waybillsWeighingAnalyses.WaybillWeighingAnalysis[]>> {
    return request({
      method: 'get',
      url: `/waybills/${waybillId}/weighing-analyses`,
      params,
    });
  },
  get(
    waybillId: number,
    analysisId: number,
  ): ApiResponse<WrappedResult<cyrian.api.waybillsWeighingAnalyses.WaybillWeighingAnalysis>> {
    return request({
      method: 'get',
      url: `/waybills/${waybillId}/weighing-analyses/${analysisId}`,
    });
  },
  create(
    waybillId: number,
    data: any,
  ): ApiResponse<WrappedResult<cyrian.api.waybillsWeighingAnalyses.WaybillWeighingAnalysis>> {
    return request({
      method: 'post',
      url: `/waybills/${waybillId}/weighing-analyses`,
      data,
    });
  },
  update(
    waybillId: number,
    analysisId: number,
    data: any,
  ): ApiResponse<WrappedResult<cyrian.api.waybillsWeighingAnalyses.WaybillWeighingAnalysis>> {
    return request({
      method: 'patch',
      url: `/waybills/${waybillId}/weighing-analyses/${analysisId}`,
      data,
    });
  },
  delete(waybillId: number, analysisId: number): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'delete',
      url: `/waybills/${waybillId}/weighing-analyses/${analysisId}`,
    });
  },
  addWaybillsWeighingAnalysesFromExcel(data: FormData): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'post',
      url: '/waybills/create-weighing-analyses-from-excel',
      headers: {
        Accept: '*/*',
        'Content-Type': 'multipart/form-data',
      },
      timeout: 90000,
      data,
    });
  },
};

export default waybillsWeighingAnalysesApi;
